import type { UseMutationOptions, useQueryClient, UseQueryOptions } from '@tanstack/react-query';

export type QueryOptionsType<F extends (...args: any) => any> = UseQueryOptions<Awaited<ReturnType<F>>>;
export type MutationOptionsType<F extends (...args: any) => any, Params = Parameters<F>[0]> = UseMutationOptions<
  Awaited<ReturnType<F>>,
  unknown,
  Params
>;

export type OptimisticUpdateContext = { previousData: unknown; queryKey: string[] };

export async function optimisticOnMutate<F extends (...args: any) => any>(
  queryClient: ReturnType<typeof useQueryClient>,
  queryKey: string[],
  data: Awaited<ReturnType<F>>
): Promise<OptimisticUpdateContext> {
  await queryClient.cancelQueries({ queryKey });

  const previousData = queryClient.getQueryData(queryKey);
  queryClient.setQueryData(queryKey, data);
  return { previousData, queryKey };
}
